module.exports = __webpack_public_path__ + "img/air_hum.b2bc5df0.png";